import { type KeyboardEvent } from "react";

// For an element with the button role, which the browser does not press on a key itself
export const activateOnKey =
  (activate: () => void) => (event: KeyboardEvent) => {
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    activate();
  };
